import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import "../styles/InformesPendientes.css";

// Normalizar API_URL (remover barra final si existe)
const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

const InformesDevueltos = () => {
  const [informes, setInformes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedInforme, setSelectedInforme] = useState(null);
  const [nuevoDetalle, setNuevoDetalle] = useState("");

  useEffect(() => {
    const fetchInformes = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/informes/devueltos`, {
          headers: getAuthHeaders()
        });
        setInformes(data);
      } catch (error) {
        console.error("❌ Error al obtener informes devueltos:", error);
      }
    };
    fetchInformes();
  }, []);

  const guardarCambios = async () => {
    try {
      await axios.put(
        `${API_URL}/api/informes/${selectedInforme.id}/reenviar`,
        {
          MotivoDetalle: nuevoDetalle
        },
        {
          headers: getAuthHeaders()
        }
      );
      setShowModal(false);
      // refrescar lista quitando el informe reenviado
      setInformes((prev) => prev.filter((inf) => inf.id !== selectedInforme.id));
    } catch (error) {
      console.error("❌ Error al guardar cambios:", error);
    }
  };

  const editarInforme = (informe) => {
    setSelectedInforme(informe);
    setNuevoDetalle(informe.MotivoDetalle || "");
    setShowModal(true);
  };

  return (
    <div className="informes-container">
      <Navbar />
      <h2 className="title">Informes Devueltos</h2>

      <div className="table-wrapper">
        <table className="informes-table">
          <thead>
            <tr>
              <th>N° Informe</th>
              <th>Motivo</th>
              <th>Fecha</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {informes.map((inf) => (
              <tr key={inf.id} className="row-hover">
                <td>{inf.NroInforme}</td>
                <td>{inf.Motivo}</td>
                <td>{inf.FechaRealizado.split("T")[0]}</td>
                <td className="acciones">
                  <button
                    className="icon-btn editar"
                    onClick={() => editarInforme(inf)}
                    title="Editar informe devuelto"
                  >
                    ✏️
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal de edición */}
      {showModal && selectedInforme && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <header className="modal-header">
              <h3 className="modal-title">Editar informe</h3>
              <button
                type="button"
                className="modal-close-btn"
                onClick={() => setShowModal(false)}
              >
                ✕
              </button>
            </header>

            <div className="modal-body">
              {/* Observación del inspector encargado */}
              {selectedInforme.Observacion && (
                <div className="modal-observacion">
                  <label className="modal-label">Observación del encargado</label>
                  <p className="modal-observacion-text">
                    {selectedInforme.Observacion}
                  </p>
                </div>
              )}

              <label className="modal-label" htmlFor="motivo-detalle">
                Motivo / Detalle
              </label>
              <textarea
                id="motivo-detalle"
                className="modal-textarea"
                value={nuevoDetalle} // 👈 controlado por estado
                onChange={(e) => setNuevoDetalle(e.target.value)}
                rows={5}
              />
              <p className="modal-hint">
                Podés agregar información extra o aclaraciones antes de guardar los cambios.
              </p>
            </div>

            <footer className="modal-footer">
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="btn btn-ghost m-2"
              >
                Cerrar
              </button>
              <button
                type="button"
                onClick={guardarCambios}
                className="btn btn-primary m-2"
              >
                Guardar cambios
              </button>
            </footer>
          </div>
        </div>
      )}
    </div>
  );
};

export default InformesDevueltos;
